module.exports = __webpack_public_path__ + "static/acumenex-logo-5d072b163a6cf1959af438231e88b4f8.jpeg";